import settings from '@/settings'

let auth = (headers) => {
  return fetch(`${settings.apetrusApi}/clientes/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let listaUsuarios = (pagination, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/usuarios/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let detalhar = (id, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/porid/?id=${id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let sendmail = (mail, headers) => {
  return fetch(`${settings.apetrusApi}/sendmail/`, {
    method: 'post',
    body: JSON.stringify(mail),
    mode: 'cors',
    headers: headers
  })
}

let contact = (mail, headers) => {
  return fetch(`${settings.apetrusApi}/sendmail/`, {
    method: 'post',
    body: JSON.stringify(mail),
    mode: 'cors',
    headers: headers
  })
}

let inserir = (empresa, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(empresa),
    mode: 'cors',
    headers: headers
  })
}

let tornarClientePlus = (data, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/tornarplus/${data.id_cliente}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let cadastrarChavePix = (headers, payload) => {
  return fetch(`${settings.apetrusApi}/clientes/editarpix/`, {
    method: 'PUT',
    body: JSON.stringify({
      'cnpj': payload.cnpj,
      'chave_pix': payload.chave_pix,
      'tipo_chave_pix': payload.tipo_chave_pix
    }),
    mode: 'cors',
    headers: headers
  })
}

let getClientesFiltrados = (filtros, headers) => {
  let url = `${settings.apetrusApi}/clientes/filtrarclientes/?`
  Object.keys(filtros).forEach((filter) => {
    url = `${url}&${filter}=${filtros[filter]}`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const meusClientes = (headers, filtros) => {
  let url = `${settings.apetrusApi}/clientes/inscritos-em-vendedor/`
  if (filtros) {
    const keys = Object.keys(filtros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${filtros[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const detalharInscritoVendedor = (headers, filtros) => {
  let url = `${settings.apetrusApi}/clientes/inscrito-em-vendedor-detalhe/`
  if (filtros) {
    const keys = Object.keys(filtros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${filtros[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  auth,
  listaUsuarios,
  detalhar,
  sendmail,
  contact,
  inserir,
  tornarClientePlus,
  cadastrarChavePix,
  getClientesFiltrados,
  meusClientes,
  detalharInscritoVendedor
}
